import $ from 'jquery';

$('.footer-bottom__scrollTop button').click(function() {
  $('html, body').animate({scrollTop:0}, '300');
})
